import { httpClient } from './httpClient';

const base = '/api/fuentes-origen';
const fallbackPaths = [base, '/api/fuentes_origen', '/api/fuentes'];

// Tries multiple common endpoints to maximize compatibility
async function listarFuentes() {
  let lastErr = null;
  for (const p of fallbackPaths) {
    try {
      const data = await httpClient.get(p);
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.data)) return data.data;
    } catch (e) {
      lastErr = e;
    }
  }
  if (lastErr) throw lastErr;
  return [];
}

export const listar = listarFuentes;
export const listarTipos = () => httpClient.get(`${base}/tipos`);
export const obtener = (id) => httpClient.get(`${base}/${id}`);
export const crear = (payload) => httpClient.post(base, payload);
export const actualizar = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminar = (id) => httpClient.del(`${base}/${id}`);

const fuentesOrigenService = {
  listar,
  listarTipos,
  obtener,
  crear,
  actualizar,
  eliminar,
};
export default fuentesOrigenService;
